import React, { Component } from 'react';
import { connect } from 'react-redux';
import { upgradeBot } from '../../actions';
import server from '../../api/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfinity } from '@fortawesome/free-solid-svg-icons';

export class PremiumTokenBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            upgradeDisabled: false
        };
    }

    renderTokenCount = () => {
        return this.props.user.tokens >= 1000 ?
            <FontAwesomeIcon icon={faInfinity} /> :
            this.props.user.tokens;
    };

    upgradeBot = async () => {
        this.setState({ upgradeDisabled: true });
        const response = await server.post("/dashboard/upgrade", {
            bot: this.props.bot,
        });

        if (response.data && response.data.upgraded !== false) {
            this.props.upgradeBot(response.data);
        }
        this.setState({ upgradeDisabled: false });
    };

    render() {
        return (
            <div className="relative overflow-hidden bg-[#1a1a1a] p-6 sm:p-12 rounded-2xl my-4 text-white">
                {/* Dark gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a]" />

                {/* Enhanced Glow Effects */}
                <div className="absolute -bottom-32 right-0 w-2/3 h-[150%] bg-gradient-to-tl from-[#FFD700]/30 via-[#FFA500]/20 to-transparent blur-3xl" />
                <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-[#FFD700]/25 via-[#FFA500]/15 to-transparent blur-2xl" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#FFD700]/[0.05] to-[#FFA500]/[0.08]" />

                {/* Premium Badge */}
                <div className="absolute -right-12 -top-12 w-48 h-48 rotate-12">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-full opacity-20 animate-pulse"></div>
                    <div className="absolute inset-2 bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-full opacity-20 animate-pulse delay-100"></div>
                    <div className="absolute inset-4 bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-full opacity-20 animate-pulse delay-200"></div>
                </div>

                <div className="flex flex-col lg:flex-row items-center justify-between relative z-10 gap-8 lg:gap-0">
                    {/* Content */}
                    <div className="relative z-10 w-full lg:max-w-xl">
                        <div className="flex items-center gap-4 mb-3">
                            <h1 className="text-3xl sm:text-4xl font-bold">
                                Upgrade Your Bot
                            </h1>
                            <div className="animate-bounce">
                                <span className="inline-flex items-center px-4 py-1 rounded-full text-lg font-bold bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-[#1a1a1a] shadow-lg shadow-[#FFD700]/30">
                                    {this.renderTokenCount()} Tokens Available
                                </span>
                            </div>
                        </div>

                        <div className="text-2xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-[#FFD700] to-[#FFA500]">
                            Unlock Premium Features Now!
                        </div>

                        <p className="text-base sm:text-lg leading-relaxed text-gray-300 mb-5 lg:pr-12">
                            You have <span className="font-bold text-[#FFD700]">{this.renderTokenCount()} premium tokens</span> ready to use! Upgrade your bot to unlock all premium features including advanced commands, custom branding, and much more.
                        </p>

                        <div className="flex flex-col gap-2">
                            <div className="flex gap-4">
                                <button
                                    onClick={this.upgradeBot}
                                    disabled={this.state.upgradeDisabled}
                                    className="relative w-full sm:w-auto px-8 py-3 rounded-lg font-semibold overflow-hidden
                                        transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 
                                        group cursor-pointer"
                                >
                                    {/* Gradient background */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-[#FFD700] via-[#FFA500] to-[#FFD700]
                                        group-hover:opacity-90 transition-opacity" />

                                    {/* Shine effect */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
                                        translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                                    {/* Button shadow */}
                                    <div className="absolute inset-0 shadow-xl shadow-[#FFD700]/20" />

                                    {/* Button text */}
                                    <span className="relative z-10 flex items-center justify-center gap-2 text-[#1a1a1a]">
                                        {this.state.upgradeDisabled ? 'Upgrading...' : 'Upgrade Now'}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Crown Icon - Hidden on mobile */}
                    <div className="hidden lg:block relative z-10 w-[100px] mr-16">
                        <div className="animate-bounce">
                            <img
                                src="/images/crown.svg"
                                alt="Premium Crown"
                                className="w-full h-auto transform hover:scale-105 transition-transform duration-500"
                            />
                        </div>
                    </div>
                </div>

                {/* Floating stars decoration */}
                <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-20">
                    <div className="absolute top-2 right-[5%] text-[#FFD700]/30 text-3xl animate-pulse delay-100">✦</div>
                    <div className="absolute top-16 right-[15%] text-[#FFA500]/40 text-2xl animate-pulse delay-300">✧</div>
                    <div className="absolute top-4 right-[25%] text-[#FFD700]/30 text-3xl animate-pulse delay-500">✦</div>
                    <div className="absolute top-20 right-[35%] text-[#FFA500]/40 text-2xl animate-pulse delay-700">✧</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    bot: state.data.bot,
    user: state.data.user
});

export default connect(mapStateToProps, { upgradeBot })(PremiumTokenBanner); 